// extracted by mini-css-extract-plugin
var _1 = "VIEbd";
var _2 = "UWvvS";
var _3 = "tkXny";
export { _1 as "children", _2 as "fullWidth", _3 as "sectionWrapper" }
